import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { MaintenancesComponent } from './maintenances.component';
var ɵ0 = { title: 'CORE.SERVICES.NAVIGATION.MAINTENANCES.TITLE' };
var routes = [
    {
        path: 'manutencoes',
        component: MaintenancesComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0
    }
];
var MaintenancesModule = /** @class */ (function () {
    function MaintenancesModule() {
    }
    return MaintenancesModule;
}());
export { MaintenancesModule };
export { ɵ0 };
